import React, {useEffect, useState} from 'react';
import ApiService from './api/ApiService';
import {Container, Typography} from "@mui/material";
import {renderDocs} from "./utils";

const Centraddedu = () => {
    const [docs, setDocs] = useState([]);
    useEffect(() => {
        ApiService.getDocs('addedu')
            .then((data) => {
                setDocs(data.docs);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <Container>
            <Typography variant="h5" gutterBottom fontWeight={'bold'} align={'center'}
                        sx={{
                            mt: 2,
                            textTransform: 'uppercase',
                        }}>
                центр дополнительного образования детей и взрослых
            </Typography>
            <Typography variant={'h6'} gutterBottom align={'center'}>Индивидуальный предприниматель Иванова Наталья
                Александровна</Typography>

            {renderDocs(docs)}
        </Container>
    );
};

export default Centraddedu;